import {ResetPasswordFormEnum, ResetPasswordFormType} from '../../../service/user/user-reset-password';

export const initialValues: ResetPasswordFormType = {
    [ResetPasswordFormEnum.Email]: '',
};
